import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=5eb2b0a0&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"
import style0 from "./approve.vue?vue&type=style&index=0&id=5eb2b0a0&prod&lang=css"
import style1 from "./approve.vue?vue&type=style&index=1&id=5eb2b0a0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2b0a0",
  null
  
)

export default component.exports